import * as React from "react";
const SvgCode = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.83333 6.66671L2.5 9.74363L5.83333 13.3334M14.1667 6.66671L17.5 9.74363L14.1667 13.3334M11.6667 3.33337L8.33333 16.6667",
      stroke: "#181B25",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgCode;
